import { CheckCircleRounded, CircleOutlined } from '@mui/icons-material';
import {
  Button,
  type SxProps,
  type Theme,
  useMediaQuery,
  useTheme,
} from '@mui/material';
import { Link } from 'react-router-dom';

interface StageStatusButtonProps {
  label: string;
  isComplete: boolean;
  onClick?: () => void;
  to?: string;
  sx?: SxProps<Theme>;
}

export function StageStatusButton({
  label,
  isComplete,
  onClick,
  to,
  sx,
}: StageStatusButtonProps) {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('md'));

  const isInteractive = !!onClick || !!to;

  return (
    <Button
      color={'success'}
      variant={'contained'}
      size={isMobile ? 'small' : 'medium'}
      sx={{
        borderRadius: '100px',
        minWidth: { xs: 'auto' },
        px: { xs: 1, sm: 3 },
        cursor: isInteractive ? 'pointer' : 'default',
        textDecoration: 'none',
        ...((sx ?? {}) as Record<string, unknown>),
        textTransform: 'uppercase',
      }}
      startIcon={
        isComplete ? (
          <CheckCircleRounded color={'primary'} style={{ fontSize: '24px' }} />
        ) : (
          <CircleOutlined color={'primary'} style={{ fontSize: '24px' }} />
        )
      }
      onClick={onClick}
      disableRipple={!isInteractive}
      {...(to ? { component: Link, to } : {})}
    >
      {label.replace(/([a-z])([A-Z])/g, '$1 $2')}
    </Button>
  );
}
